import React from 'react';
import { useFela } from '../../index';
import { LabelProps } from './LabelProps';
import { WithTheme } from '../../Theme';

const defaultStyle = ({
  disabled,
  theme,
}: WithTheme<Pick<LabelProps, 'disabled'>>) => ({
  fontSize: theme.typography.fontSize.m.rem,
  fontFamily: theme.typography.fontFamily.primary.main,
  fontWeight: 400,
  color: theme.palette.color3.hex,
  lineHeight: 1.5,
  display: 'inline-block',
  cursor: 'pointer',
  userSelect: 'none',
  extend: [
    {
      condition: disabled,
      style: {
        color: theme.palette.color10.hex,
        cursor: 'not-allowed',
      },
    },
  ],
});

const Label = ({
  as = 'label',
  style,
  htmlFor,
  dmId = 'dm-label',
  id,
  required = false,
  disabled = false,
  children,
  ...otherProps
}: LabelProps): JSX.Element => {
  const { css } = useFela({ disabled });
  const Component = as;
  return (
    <Component
      // @ts-expect-error Component needs the correct type; maybe something like React.ComponentType
      htmlFor={as === 'label' ? htmlFor : null}
      data-designsystem
      data-dmid={dmId}
      id={id || dmId} // todo: dmId should be removed, as soon as id prop is required (myt-7757)
      className={css([defaultStyle, style])}
      {...otherProps}>
      <>
        {children}
        {required ? '*' : ''}
      </>
    </Component>
  );
};

export default Label;
